import provideDataHook from '~/helpers/provideDataHook';
import { objectsFilterDataHook } from '../objectsFilterDataHook';
import { RedirectHandler } from '../RedirectHandler';

export default provideDataHook(
  'FilterPage-TransportAndMachines',
  objectsFilterDataHook({ mainCategories: ['heavy_transport', 'machines'] }),
  { skipSpinner: true }
)(RedirectHandler);
